import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Rito } from '@app/models/rito.model';
import { RitoService } from '@app/services/rito.service';

@Component({
  selector: 'app-rito-form',
  templateUrl: './rito-form.component.html'
})
export class RitoFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  rito: Rito = new Rito();
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ritoService: RitoService) { }

  ngOnInit() {
    const id = this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Rito' : 'Novo Rito';

      if (!id) {
        return;
      }

      this.ritoService.obterPorId(id).toPromise().then(
        data => this.rito = data,
        () => this.router.navigate(['./configuracoes/rito']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.ritoService.gravar(this.rito).toPromise().then(
      () => this.router.navigate(['./configuracoes/rito']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
